import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { CustomerMsisdnNotificationPaginatorInterface } from '../models/customer-msisdn-notification-paginator.interface';

@Injectable()
export class NotificationService {

  constructor(private apiService: ApiService) {}

  /**
   * Get msisdn notifications
   */
  getMsisdnNotifications(phoneNumber: string, page: number, total: number): Observable<CustomerMsisdnNotificationPaginatorInterface> {
    return this.apiService.get('msisdn/notifications/' + phoneNumber + '/' + page + '/' + total);
  }

  /**
   * Delete msisdn notifications
   */
  deleteMsisdnNotifications(phoneNumber: string, id: number): Observable<any> {
    return this.apiService.delete('msisdn/notification/' + phoneNumber + '/' + id);
  }

  /**
   * Get customer notifications
   */
  getCustomerNotifications(type: string, page: number, total: number): Observable<CustomerMsisdnNotificationPaginatorInterface> {
    return this.apiService.get('customer/notifications/' + type + '/' + page + '/' + total);
  }

  /**
   * Delete customer notifications
   */
  deleteCustomerNotifications(id: number): Observable<any> {
    return this.apiService.delete('customer/notification/' + id);
  }
}
